import { useNavigate } from 'react-router';
import { useMutation } from '@tanstack/react-query';
import * as R from 'Router/routes';
import { fetchData } from '../../../utils';
import { useStore } from '../../useStore';
import useSmartlook from '../../useSmartlook';

export default function useBankIDSessionsConfirmMutation() {
  const navigate = useNavigate();
  const { error } = useSmartlook();
  const [storeBankId, setStoreBankId] = useStore((store) => store.bankId);
  return useMutation<void, unknown, { uuid: string }>({
    mutationFn: async ({ uuid }) => {
      try {
        return await fetchData(`/client/bankid/sessions/${uuid}/confirm`, {
          method: 'POST',
        });
      } catch (e) {
        error(
          '[useBankIDSessionsConfirmMutation][POST /client/bankid/sessions/{uuid}/confirm]',
          e,
        );
        setStoreBankId({
          bankId: {
            ...storeBankId,
            error: true,
          },
        });
        navigate(R.BANK_ID_ERROR);
        return undefined;
      }
    },
  });
}
